export default function extractFlightsFromSettings(settings: any): string[] {
    if (!settings) {
        return [];
    }

    let flights = [];
    [
        'addin',
        'an',
        'auth',
        'cal',
        'cmp',
        'doc',
        'eventify',
        'fms',
        'fwk',
        'getstarted',
        'grp',
        'gsx',
        'help',
        'honeybee',
        'inline',
        'iris',
        'lightning',
        'lpc',
        'mc',
        'notes',
        'nps',
        'peo',
        'people',
        'mc',
        'platform',
        'playMyEmails',
        'rp',
        'sea',
        'sxs',
        'todo',
        'tra',
        'tri',
        'sig',
        'mon',
        'usv',
        'woven',
    ].forEach(prefix => {
        Object.keys(settings[prefix] || {}).forEach(key => {
            if (settings[prefix][key] === true) {
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2345 (50,30): Argument of type 'string' is not assignable to parameter of type 'never'.
                // @ts-ignore
                flights.push(`${prefix}-${key}`);
            }
        });
    });

    return flights;
}
